module.exports = 'spaceships'


//////////////////
// WEBPACK FOOTER
// ./client/assets/spaceships.blend
// module id = 18
// module chunks = 0